import { Box, List, SearchField } from '@iheartjane/reefer';
import { useState } from 'react';

import { FilterCheckBox } from '@jane/bloom/components/productListingPage/categoryAndFilterSelectors/filterSelector/filterCheckBox';
import {
  useProductSearchFilters,
  useSearchParamFilter,
} from '@jane/bloom/hooks/filters';
import { FilterCategoryLabel } from '@jane/bloom/hooks/filters/useProductSearchFilters';
import { normalizeString } from '@jane/bloom/utils/strings/normalizeString';
import type { SearchFilterFacet } from '@jane/bloom/viewModels/productSearchFilters';

import { FilterActions } from './filterActions';

import styles from './filterWithSearch.module.css';

type SEARCH_FILTERS = 'brands' | 'terpenes';

export interface FilterWithSearchButtonProps {
  availableProductsCount?: number;
  /** Injected by FilterButtonWrapper */
  closePopover?: () => void;
  filterKey: SEARCH_FILTERS;
}

export const FilterWithSearchButton = ({
  availableProductsCount,
  closePopover,
  filterKey,
}: FilterWithSearchButtonProps) => {
  const { getProductSearchFilterOptions } = useProductSearchFilters();
  const { clearFilter } = useSearchParamFilter(filterKey);
  const [search, setSearch] = useState('');
  const filterOptions = getProductSearchFilterOptions(filterKey);

  const listItems = filterOptions.filter(
    (searchItem: SearchFilterFacet) =>
      searchItem.label &&
      normalizeString(searchItem.value.toLowerCase()).includes(
        normalizeString(search.toLowerCase())
      )
  );

  return (
    <Box px={16} pt={16}>
      <Box
        className={styles['searchBox']}
        pt={12}
        px={8}
        zIndex={1}
        background="grays-white"
        position="inherit"
      >
        <SearchField
          name="filter-search"
          label="filter-search"
          onChange={setSearch}
          disableMobileInputStyling
          mb={8}
        />
      </Box>
      <List label={FilterCategoryLabel[filterKey]} mb={16}>
        {listItems.map((item: SearchFilterFacet) => {
          return (
            <FilterCheckBox
              filter={item}
              filterKey={filterKey}
              key={`${filterKey}${item.value}`}
            />
          );
        })}
      </List>
      <FilterActions
        availableProductsCount={availableProductsCount}
        handleClearAll={clearFilter}
        handleClose={closePopover}
        sticky
      />
    </Box>
  );
};
